import { channels } from '@/mocks/channels';

const quickLinks = [
  { href: '#feed', label: '实时速报' },
  { href: '#hot', label: '全网热榜' },
  { href: '#timeline', label: '事件脉络' },
  { href: '#feature', label: '深度专题' },
  { href: '#faq', label: '吃瓜指南' },
  { href: '#about', label: '关于我们' },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2">
              <span className="grid h-9 w-9 place-items-center rounded-lg bg-primary-500 font-heading text-xl text-background-50">
                料
              </span>
              <span className="font-heading text-2xl text-background-50">看料站</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-300">
              全网热点实时速报站。紧盯娱乐、影视综艺与社会动态，滚动更新最新爆料与事件进展，帮你掌握最新鲜的料。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="mailto:hello@kanliaozhan.example"
                className="grid h-10 w-10 place-items-center rounded-full bg-background-800 text-foreground-200 transition hover:bg-primary-500 hover:text-background-50"
                aria-label="邮箱联系"
              >
                <i className="ri-mail-line" />
              </a>
              <a
                href="#top"
                className="grid h-10 w-10 place-items-center rounded-full bg-background-800 text-foreground-200 transition hover:bg-primary-500 hover:text-background-50"
                aria-label="社交动态"
              >
                <i className="ri-chat-3-line" />
              </a>
              <a
                href="#feed"
                className="grid h-10 w-10 place-items-center rounded-full bg-background-800 text-foreground-200 transition hover:bg-primary-500 hover:text-background-50"
                aria-label="实时速报"
              >
                <i className="ri-flashlight-line" />
              </a>
            </div>
          </div>

          <nav aria-label="站内导航">
            <h3 className="font-heading text-base text-background-50">快速浏览</h3>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-300 transition hover:text-secondary-300">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="栏目频道">
            <h3 className="font-heading text-base text-background-50">栏目频道</h3>
            <ul className="mt-4 space-y-2.5">
              {channels.map((c) => (
                <li key={c.id}>
                  <a href="#channels" className="text-sm text-foreground-300 transition hover:text-secondary-300">
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-800 pt-6 text-xs text-foreground-400 sm:flex-row">
          <p>© {new Date().getFullYear()} 看料站 · 全网热点实时速报，仅供公开信息参考</p>
          <p className="text-foreground-500">尊重原创版权 · 内容请以权威来源为准</p>
        </div>
      </div>
    </footer>
  );
}